module.exports = "<div class=\"text-center\"><img src=\"../assets/images/success.png\"/><div class=\"text-2x\" style=\"font-size: 20px;white-space: pre-line;\" ng-bind=\"$ctrl.$stateParams.msg\"></div><footer></footer></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/thank-you/thank-you.pug
// module id = 276
// module chunks = 0